import React, { useState, useEffect, useRef } from 'react';
import logo from './log.png';
import axios from 'axios';
import zhCN from 'antd/es/locale/zh_CN';
import './App.css';
import styled from 'styled-components';
import jux from './jux.png';
import Rule from './rule';
import dayjs from 'dayjs';
import PaidPrediction from './paidPrediction';
import Grouping from './grouping';
import { Row, Col, ConfigProvider, Button, Tabs, Form, InputNumber, Switch, Select, DatePicker, Input, Table, message } from 'antd';
import { LeftDiv, Modals, LeftTop, Title, HB, All, Headers, RightDiv, Image, TableContainer, Container, TabsContainer, InfoDiv, InfoItem, Name, Searchs, Parameter } from './style'
const { Option } = Select;
const { Search } = Input;
export const BackgroundDiv = styled.div`
  width: 181px;
  height: 40px;
  background-image: url(${jux});
  background-size: cover;
  display: flex;
  align-items: center;
  color: white;
`;
export const Forms = styled(Form)`
  padding: 15px 25px;
`;
export const Submit = styled(Button)`
  position: absolute;
  right: 10px;
  padding: 5px 10px;
  width: 95px;
  height: 35px;
  background: #0A8CEB;
  border-radius: 29px;
`;
export const StyledTabs = styled(Tabs)`
  padding: 15px 25px;
  .ant-tabs-nav .ant-tabs-tab-active{
    color: #000;
    background: #0A8CEB;
  }
  .ant-tabs-card.ant-tabs-top >.ant-tabs-nav .ant-tabs-tab+.ant-tabs-tab{
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #646566;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 24px;
    text-align: left;
    font-style: normal
  }
`;
const App = () => {
  var inputdata = { "setlinfo": { "psn_no": "13110081311251484703", "mdtrt_id": "369263403", "gend": "1", "setl_id": "234247736", "hi_no": "13110081311251484703", "medcasno": "2204242", "dcla_time": "2024-02-14 16:23:39", "ntly": "CHN", "prfs": "27", "curr_addr": "***", "emp_name": "", "emp_addr": "", "emp_tel": "", "poscode": "", "coner_name": "***", "patn_rlts": "0", "coner_addr": "****", "coner_tel": "13171717239", "nwb_adm_type": "", "nwb_bir_wt": 0.00, "nwb_adm_wt": 0.00, "mul_nwb_bir_wt": "", "mul_nwb_adm_wt": "", "opsp_diag_caty": "", "opsp_mdtrt_date": null, "adm_way": "2", "trt_type": "1", "adm_time": "2024-04-12 10:26:30", "refldept_dept": "", "dscg_time": "", "dscg_caty": "A04   ", "otp_wm_dise": "肠梗阻", "wm_dise_code": "K56.700", "otp_tcm_dise": "", "tcm_dise_code": "", "vent_used_dura": "", "pwcry_bfadm_coma_dura": "", "pwcry_afadm_coma_dura": "", "spga_nurscare_days": 0, "lv1_nurscare_days": 0, "scd_nurscare_days": 0, "lv3_nurscare_days": 0, "dscg_way": "1", "acp_medins_name": "", "acp_optins_code": "", "bill_code": "13061020", "bill_no": "10", "biz_sn": "214831", "days_rinp_flag_31": "1", "days_rinp_pup_31": "", "chfpdr_code": "", "setl_begn_date": "", "setl_end_date": "", "medins_fill_dept": "医保科", "medins_fill_psn": "住院处", "age": 38, "resp_nurs_code": "", "stas_type": "0", "hi_paymtd": "2", "act_ipt_days": 30, "medfee_sumamt": 10000, "hifp_pay": 7000, "admdvs": "130200", "fixmedins_code": "H13020300630", "mdcs_type": "310" }, "opspdiseinfo": [], "diseinfo": [], "oprninfo": [], "icuinfo": [], "bldinfo": [] };
  const [form] = Form.useForm();
  const zdRef = useRef(null);
  const ssRef = useRef(null);
  const [zdModal, setZdModal] = useState(false);
  const [ssModal, setSsModal] = useState(false);
  const [datas, setData] = useState([]);
  const [datae, setDatae] = useState([]);
  const [diagnosisList, setDiagnosisList] = useState([]);
  const [diagnosisData, setDiagnosisData] = useState([]);
  const [operationData, setOperationData] = useState([]);
  const [operationList, setOperationList] = useState([]);
  const [response, setResponse] = useState({});
  const [requestParam, setRequestParam] = useState([]);
  const [info, setInfo] = useState({});
  const mapping = {
    "1": "西医",
    "2": "主病",
    "3": "主证"
  };
  const handleClickOutside = (event) => {
    if (zdRef.current && !zdRef.current.contains(event.target)) {
      setZdModal(false);
    }
    if (ssRef.current && !ssRef.current.contains(event.target)) {
      setSsModal(false);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    if (id) {
      axios({
        method: 'post',
        url: 'http://124.222.139.157:6869/dip/dip/group/getApiResult',
        params: {
          id
        },
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
        .then(function (res) {
          const response = JSON.parse(res.data.response);
          const requestParam = JSON.parse(res.data.requestParam);
          console.log(response, requestParam);
          const {
            psn_name,
            medcasno,
            adm_time,
            mdcs_type,
            age,
            act_ipt_days,
            medfee_sumamt,
            dscg_time,
            hifp_pay,
            nwb_age,
            gend,
            dscg_way,
            medfee_cms_sumamt,
          } = requestParam.setlinfo;
          setInfo({
            name: psn_name,
            number: medcasno,
            time: adm_time,
            gend: gend,
          });
          setRequestParam(requestParam.feeStrucList || []);
          setResponse(response);
          setDiagnosisList(requestParam.diseinfo);
          setOperationList(requestParam.oprninfo);
          form.setFieldsValue({
            mdcs_type,
            age,
            act_ipt_days,
            medfee_sumamt,
            dscg_time: dscg_time ? dayjs(dscg_time) : null,
            hifp_pay,
            nwb_age,
            dscg_way,
            medfee_cms_sumamt,
          });
        })
        .catch(function (error) {
          message.error('Error:', error);
        });
    } else {
      const {
        mdcs_type,
        age,
        act_ipt_days,
        medfee_sumamt,
        dscg_time,
        hifp_pay,
        nwb_age,
        dscg_way,
        medfee_cms_sumamt
      } = inputdata.setlinfo
      form.setFieldsValue({
        mdcs_type,
        age,
        act_ipt_days,
        medfee_sumamt,
        dscg_time,
        hifp_pay,
        nwb_age,
        dscg_way,
        medfee_cms_sumamt,
      });
    }

    // 请求其他资源
    axios.get('/icd10.json')
      .then(response => {
        setData(response.data);
      });

    axios.get('/icd9.json')
      .then(response => {
        setDatae(response.data);
      });

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const items = [
    {
      key: '1',
      label: '付费预测',
      children: <PaidPrediction response={response} form={form} requestParam={requestParam} />,
    },
    {
      key: '2',
      label: '分组推荐',
      children: <Grouping response={response} />,
    },
    {
      key: '3',
      label: '规则质控',
      children: <Rule qualContList={response.qualContList} />,
    },
  ];
  const columns = [
    {
      title: '诊断编码',
      dataIndex: 'diag_code',
      width: 150,
      key: 'diag_code',
    },
    {
      title: '诊断名称',
      dataIndex: 'diag_name',
      key: 'diag_name',
    },
    {
      title: '诊断类型',
      dataIndex: 'diag_type',
      key: 'diag_type',
      width: 100,
      render: (text) => {
        return mapping[text] || text;
      }
    },
    {
      title: '主诊断',
      dataIndex: 'maindiag_flag',
      key: 'maindiag_flag',
      width: 100,
      render: (text, record) => (
        <Switch
          checked={record.maindiag_flag}
          checkedChildren="主" unCheckedChildren="关"
          onChange={(checked) => handleSwitchChange(record, checked)}
        />
      ),
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <a onClick={() => handleDelete(record.diag_code)}>删除</a>
      ),
    },
  ];
  const columnss = [
    {
      title: '手术编码',
      width: 150,
      dataIndex: 'oprn_oprt_code',
      key: 'oprn_oprt_code',
    },
    {
      title: '手术名称',
      dataIndex: 'oprn_oprt_name',
      key: 'oprn_oprt_name',
    },
    {
      title: '主手术',
      dataIndex: 'oprn_oprt_type',
      width: 100,
      key: 'oprn_oprt_type',
      render: (text, record) => (
        <Switch
          checkedChildren="主" unCheckedChildren="关"
          checked={record.oprn_oprt_type}
          onChange={(checked) => handleSwitchChangeOp(record.oprn_oprt_code, checked)}
        />
      ),
    },
    {
      title: '操作',
      width: 100,
      key: 'action',
      render: (_, record) => (
        <a onClick={() => handleDeleteOp(record.oprn_oprt_code)}>删除</a>
      ),
    },
  ];
  const diagnosis = [
    {
      title: '诊断编码',
      dataIndex: 'diag_code',
      width: 150,
      key: 'diag_code',
    },
    {
      title: '诊断名称',
      dataIndex: 'diag_name',
      key: 'diag_name',
    },
    {
      title: '诊断类型',
      dataIndex: 'diag_type',
      key: 'diag_type',
      width: 100,
      render: (text) => {
        return mapping[text] || text;
      }
    },
    {
      title: '国临码',
      dataIndex: 'address',
      key: 'address',
      width: 100,
    },
    // {
    //   title: '拼音码',
    //   dataIndex: 'pym',
    //   key: 'pym',
    // },
  ];
  const operation = [
    {
      title: '手术编码',
      dataIndex: 'oprn_oprt_code',
      key: 'oprn_oprt_code',
      width: 150,
    },
    {
      title: '手术名称',
      dataIndex: 'oprn_oprt_name',
      key: 'oprn_oprt_name',
    },
    {
      title: '国临码',
      dataIndex: 'address',
      key: 'address',
      width: 100,
    },
    // {
    //   title: '拼音码',
    //   dataIndex: 'pym',
    //   key: 'pym',
    // },
  ];
  // 诊断删除
  const handleDelete = (key) => {
    const updatedArr = diagnosisList.filter(item => item.diag_code !== key);

    // 检查删除后是否还有 maindiag_flag 为 true 的数据
    const hasMainDiag = updatedArr.some(item => item.maindiag_flag === true);

    if (!hasMainDiag && updatedArr.length > 0) {
      // 如果没有 maindiag_flag 为 true 的数据，并且列表不为空，设置第一条数据的 maindiag_flag 为 true
      updatedArr[0].maindiag_flag = true;
    }

    setDiagnosisList(updatedArr);
  };
  // 手术删除
  const handleDeleteOp = (key) => {
    // 先过滤掉需要删除的项
    const updatedArr = operationList.filter(item => item.oprn_oprt_code !== key);
    // 检查删除后的列表中是否有 oprn_oprt_code 为 true 的数据
    const hasTrueOpCode = updatedArr.some(item => item.oprn_oprt_type === true);
    if (!hasTrueOpCode && updatedArr.length > 0) {
      // 如果没有 oprn_oprt_code 为 true 的项，并且数组不为空，设置第一条数据的 oprn_oprt_code 为 true
      updatedArr[0].oprn_oprt_type = true;
    }
    // 更新 state
    setOperationList(updatedArr);
  };


  const handleSwitchChange = (record, checked) => {
    const {diag_code,diag_type} = record;
    // 如果开关被切换为选中状态 (checked 为 true)
    if (checked) {

      const updatedList = diagnosisList.map(item => {
        console.log(item.diag_code, diag_code);
        // 如果 diag_code 匹配，设置 maindiag_flag 为 true
        if (item.diag_code === diag_code) {
          return { ...item, maindiag_flag: true };
        }
        // 否则设置 maindiag_flag 为 false
        return { ...item, maindiag_flag: diag_type === item.diag_type ? false : item.maindiag_flag };
      });
      setDiagnosisList(updatedList); // 更新状态，重新渲染组件
    } else {
      // 如果开关被切换为未选中状态 (checked 为 false)
      const updatedList = diagnosisList.map(item => {
        // 假设 currentItem 是当前需要设置为 false 的项
        const currentItem = diagnosisList.find(item => item.diag_code === diag_code);

        return item.diag_code === diag_code
          ? { ...item, maindiag_flag: false } // 如果 diag_code 匹配，设置 maindiag_flag 为 false
          : item.diag_type === currentItem.diag_type
            ? { ...item, maindiag_flag: false } // 如果 diag_type 相同，设置 maindiag_flag 为 false
            : item; // 保持其他项不变
      });
      setDiagnosisList(updatedList); // 更新状态，重新渲染组件
    }
  };
  const handleSwitchChangeOp = (key, checked) => {
    if (checked) {
      const updatedList = operationList.map(item =>
        item.oprn_oprt_code === key ? { ...item, oprn_oprt_type: true } : { ...item, oprn_oprt_type: false }
      );

      setOperationList(updatedList);
    } else {
      const updatedList = operationList.map(item =>
        item.oprn_oprt_code === key ? { ...item, oprn_oprt_type: false } : item
      );
      setOperationList(updatedList);
    }
  };
  // 诊断信息添加
  const handleRowDoubleClick = (record) => {
    setDiagnosisList(prevList => {
      // 如果 prevList 为空，oprn_oprt_type 为 true，否则为 false
      const maindiag_flag = prevList.length === 0 ? true : false;
      const newDiagnosisList = [...prevList, { ...record, maindiag_flag }];

      // 使用 Set 去重（Set 是根据引用去重的，所以这里保持引用不变的对象相同）
      const uniqueList = [...new Set(newDiagnosisList.map(item => JSON.stringify(item)))].map(item => JSON.parse(item));

      return uniqueList;
    });
    setZdModal(false)
  };
  // 手术信息添加
  const handleRowDoubleClickOp = (record) => {
    setOperationList(prevList => {
      // 如果 prevList 为空，oprn_oprt_type 为 true，否则为 false
      const oprn_oprt_type = prevList.length === 0 ? true : false;
      const newDiagnosisList = [...prevList, { ...record, oprn_oprt_type }];

      // 使用 Set 去重（Set 是根据引用去重的，所以这里保持引用不变的对象相同）
      const uniqueList = [...new Set(newDiagnosisList.map(item => JSON.stringify(item)))].map(item => JSON.parse(item));

      return uniqueList;
    });
    setSsModal(false);
  };

  function filterData(searchTerm) {
    return datas.filter(item => {
      const search = searchTerm.toLowerCase();
      const matchDiagName = item.diag_name.toLowerCase().includes(search);
      const matchPym = item.pym.toLowerCase().startsWith(search);
      const matchDiagCode = item.diag_code.toLowerCase().includes(search);
      if (searchTerm === "") {
        return true;
      }
      return matchDiagName || matchPym || matchDiagCode;
    });
  }
  function filterDataOP(searchTerm) {
    return datae.filter(item => {
      const search = searchTerm.toLowerCase();
      const matchDiagName = item.oprn_oprt_name.toLowerCase().includes(search);
      const matchPym = item.pym.toLowerCase().startsWith(search);
      const matchDiagCode = item.oprn_oprt_code.toLowerCase().includes(search);
      if (searchTerm === "") {
        return true;
      }
      return matchDiagName || matchPym || matchDiagCode;
    });
  }

  const onSubmit = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const fixmedinsCode = urlParams.get('fixmedinsCode');
    const admdvs = urlParams.get('admdvs');
    if (fixmedinsCode) {
      inputdata.setlinfo.fixmedins_code = fixmedinsCode;
    }
    if (admdvs) {
      inputdata.setlinfo.admdvs = admdvs;
    }
    const updatedData = diagnosisList.map(item => {
      const { pym, ...rest } = item;
      return {
        ...rest,
        maindiag_flag: item.maindiag_flag ? '1' : '0'
      };
    });
    const updatedDatas = operationList.map(item => ({
      ...item,
      oprn_oprt_type: item.oprn_oprt_type ? '1' : '0'
    }));
    inputdata.diseinfo = updatedData;
    inputdata.oprninfo = updatedDatas;
    let formdata = form.getFieldsValue();
    inputdata.setlinfo.mdcs_type = formdata.mdcs_type;
    inputdata.setlinfo.age = formdata.age;
    inputdata.setlinfo.act_ipt_days = formdata.act_ipt_days;
    inputdata.setlinfo.medfee_sumamt = formdata.medfee_sumamt;
    inputdata.setlinfo.dscg_time = formdata.dscg_time ? formdata.dscg_time.format("YYYY-MM-DD HH:mm:ss") : '';
    inputdata.setlinfo.hifp_pay = formdata.hifp_pay;
    inputdata.setlinfo.nwb_age = formdata.nwb_age;
    inputdata.setlinfo.gend = formdata.gend;
    inputdata.setlinfo.dscg_way = formdata.dscg_way;
    inputdata.setlinfo.adm_time = info.time;
    if (inputdata.diseinfo.length !== 0) {
      axios({
        method: 'post',
        url: 'http://124.222.139.157:6869/dip/dip/group/preGroup',
        data: JSON.stringify(inputdata),
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
        .then(function (res) {
          setResponse(res.data);
          setRequestParam(res.data.feeStrucList || [])
        })
        .catch(function (error) {
          console.error('Error:', error);
        });
    } else {
      message.error('诊断信息不得为空!!!');
    }

  }

  return (
    <All>
      <Headers>
        <Image src={logo} alt="Placeholder" />
        <Submit type="primary" onClick={onSubmit}>预测分析</Submit>
      </Headers>
      <Container>
        <BackgroundDiv>
          <Name>
            姓名：{info.name}
          </Name>
        </BackgroundDiv>
        <InfoDiv>
          <InfoItem>住院号：<Parameter>{info.number}</Parameter></InfoItem>
          <InfoItem>住院时间：<Parameter>{info.time}</Parameter></InfoItem>
          <InfoItem>性别：<Parameter>{info.gend == 2 ? '女' : '男'}</Parameter></InfoItem>
        </InfoDiv>
      </Container>
      <Searchs>
        <Row>
          <Col span={24}>
            <Forms
              form={form}
            >
              <Row gutter={16}>
                <Col span={3}>
                  <Form.Item label="医保类型" name="mdcs_type">
                    <Select
                      width="100%"
                      placeholder="请输入"
                    >
                      <Option value="">请选择</Option>
                      <Option value="390">居民</Option>
                      <Option value="310">职工</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item label="离院方式" name="dscg_way">
                    <Select
                      style={{ width: "100%" }}
                      placeholder="请输入"
                    >
                      <Option value="1">医嘱离院</Option>
                      <Option value="2">医嘱转院</Option>
                      <Option value="3">医嘱转社区···</Option>
                      <Option value="4">非医嘱离院</Option>
                      <Option value="5">死亡</Option>
                      <Option value="9">其他</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item label="出院日期" name="dscg_time">
                    <DatePicker
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      placeholder="请输入"
                      width="100%"
                    />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Form.Item label="年龄" name="age">

                    <InputNumber placeholder="请输入" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Form.Item label="年龄天" name="nwb_age">
                    <InputNumber placeholder="请输入" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Form.Item label="住院天数" name="act_ipt_days">
                    <InputNumber placeholder="请输入" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item label="总费用" name="medfee_sumamt">
                    <InputNumber placeholder="请输入" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item label="统筹费用" name="hifp_pay">
                    <InputNumber placeholder="请输入" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item label="中医费用" name="medfee_cms_sumamt">
                    <InputNumber placeholder="请输入" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>
            </Forms>
          </Col>
        </Row>
      </Searchs>
      <TabsContainer>
        <StyledTabs
          defaultActiveKey="1"
          type="card"
          size='small'
          items={items}
        />
      </TabsContainer>
      <TableContainer>
        <LeftDiv>
          <LeftTop>
            <HB />
            <Title>诊断信息</Title>
            <div ref={zdRef}>
              <Search style={{ width: '280px', marginLeft: '15px' }} placeholder="请输入诊断编码或名称" onFocus={(e) => { setZdModal(true) }} onChange={(e) => { setDiagnosisData(filterData(e.target.value)) }} />
              {zdModal &&
                <Modals >
                  <ConfigProvider locale={zhCN}>
                    <Table
                      style={{ marginTop: '5px' }}
                      rowKey='diag_code'
                      bordered
                      onRow={(record) => ({
                        onDoubleClick: () => handleRowDoubleClick(record),
                      })}
                      columns={diagnosis}
                      dataSource={diagnosisData}
                      size="small"
                      pagination={{
                        position: ['bottomLeft'],
                        pageSize: 5,
                        total: diagnosisData.length,
                        showSizeChanger: false,
                        showQuickJumper: true,
                        showTotal: (total) => `共 ${total} 条`,
                      }}
                    />
                  </ConfigProvider>
                </Modals>
              }
            </div>
          </LeftTop>
          <Table bordered scroll={{ y: 260 }} columns={columns} dataSource={diagnosisList} style={{ marginTop: '10px' }} pagination={false} rowKey="diag_code" />
        </LeftDiv>
        <div style={{ width: '10px' }} />
        <RightDiv>
          <LeftTop>
            <HB />
            <Title>手术信息</Title>
            <div ref={ssRef}>
              <Search style={{ width: '280px', marginLeft: '15px' }} placeholder="请输入诊断编码或名称" onFocus={(e) => { setSsModal(true) }} onChange={(e) => { setOperationData(filterDataOP(e.target.value)) }} />
              {ssModal &&
                <Modals >
                  <ConfigProvider locale={zhCN}>
                    <Table
                      rowKey='oprn_oprt_code'
                      bordered
                      columns={operation}
                      dataSource={operationData}
                      size="small"
                      onRow={(record) => ({
                        onDoubleClick: () => handleRowDoubleClickOp(record),
                      })}
                      scroll={{ y: 220 }}
                      pagination={{
                        position: ['bottomLeft'],
                        pageSize: 5,
                        total: operationData.length,
                        showSizeChanger: false,
                        showQuickJumper: true,
                        showTotal: (total) => `共 ${total} 条`,
                      }}
                    />
                  </ConfigProvider>
                </Modals>
              }
            </div>

          </LeftTop>
          <Table rowKey='oprn_oprt_code' bordered columns={columnss} dataSource={operationList} style={{ marginTop: '10px' }} pagination={false} scroll={{ y: 260 }} />
        </RightDiv>
      </TableContainer>
    </All>

  );
};

export default App;
